import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CouponUsageStatsRequest,
  CouponUsageStatsResponse,
  CouponVerifyRequest,
  CouponVerifyResponse,
  injectCouponApi
} from './coupon-api';
import { CouponDbService } from './coupon-db.service';
import { Coupon, CouponMonthlyUsageBucket } from './coupon.models';
//prueba commit conjunto app y shared-lib
@Injectable({ providedIn: 'root' })
export class CouponService {
  private couponApi = injectCouponApi();
  private couponDbService = inject(CouponDbService);

  /**
   * Gets a coupon by its unique code.
   * @param code Coupon code.
   * @returns Observable emitting the first matching coupon or `undefined`.
   */
  getCouponByCode$(code: string): Observable<Coupon> {
    return this.couponDbService.getOneWhere$({ where: { code }, limit: 1 });
  }

  /**
   * Gets the first coupon generated by a specific referrer.
   * @param referrerId Referrer user ID.
   * @returns Observable emitting the first referred coupon or `undefined`.
   */
  getFirstReferredCoupon$(referrerId: string): Observable<Coupon> {
    return this.couponDbService.getOneWhere$({ where: { 'user.id': referrerId }, limit: 1 });
  }

  /**
   * Verifies whether a coupon is valid for a given request payload.
   * @param data Coupon verification request payload.
   * @returns Promise with coupon validation response from backend function.
   * @throws Propagates backend function errors (invalid arguments, business rules, auth, etc.).
   */
  verifyCoupon(request: CouponVerifyRequest): Promise<CouponVerifyResponse> {
    return this.couponApi.verify(request);
  }

  /**
   * Gets usage statistics for a coupon (current and previous month counts).
   * @param request Usage stats request payload.
   */
  getCouponUsageStats(request: CouponUsageStatsRequest): Promise<CouponUsageStatsResponse> {
    return this.couponApi.getUsageStats(request);
  }

  /**
   * Gets monthly usage counts for a coupon over a given range,
   * computed from the `orders` ElasticSearch index.
   * @param couponCode Coupon code to filter by.
   * @param monthsBack Number of months back from now to include (defaults to 14).
   */
  getCouponMonthlyUsage(couponCode: string, monthsBack?: number): Promise<CouponMonthlyUsageBucket[]> {
    return this.couponDbService.getMonthlyUsageByOrders(couponCode, monthsBack);
  }
}


//FALTA
// calcular el monto total tomando en cuenta que sea % o total
// aplicar el cupon si existe al cambiar usuario u otros casos.
// el caso es que el usuario puede tener cupon pero es aplicable solo si tiene unos tipos de producto
// por lo tanto debemos actualizarlo al refrescar el cart
